const ADMIN_EMAILS = [
  'cecilie.agotnes@gmail.com',
  'christian.strommen@me.com',
  'slavka1406@gmail.com'
]

const ADMIN_EMAIL_SET = new Set(ADMIN_EMAILS)

const normalizeAdminEmail = (email) =>
  typeof email === 'string' ? email.trim().toLowerCase() : ''

const isAllowedAdminEmail = (email) =>
  ADMIN_EMAIL_SET.has(normalizeAdminEmail(email))

export default ADMIN_EMAILS
export { ADMIN_EMAILS, isAllowedAdminEmail, normalizeAdminEmail }
